import React from "react";
import { FaUserCircle } from "react-icons/fa";

/**
 * UserAvatar — shows profile image if available, otherwise a styled icon.
 * Props:
 * src — image URL (null/undefined = show icon)
 * size — px number (default 40)
 * alt — alt text
 * style — extra inline styles on the wrapper
 * className— extra classes on the wrapper
 */
const UserAvatar = ({ src, size = 40, alt = "user", style = {}, className = "" }) => {
 const [imgError, setImgError] = React.useState(false);

 React.useEffect(() => {
   setImgError(false);
 }, [src]);

 const showIcon = !src || imgError;

 return (
 <span
 className={className}
 style={{
 display: "inline-flex",
 alignItems: "center",
 justifyContent: "center",
 width: size,
 height: size,
 borderRadius: "50%",
 overflow: "hidden",
 flexShrink: 0,
 background: showIcon
 ? "linear-gradient(135deg, #0078D7, #886cc0)"
 : "transparent",
 ...style,
 }}
 >
 {showIcon ? (
 <FaUserCircle size={size * 0.65} color="#fff" />
 ) : (
 <img
 src={src}
 alt={alt}
 width={size}
 height={size}
 style={{ objectFit: "cover", width: "100%", height: "100%" }}
 onError={() => setImgError(true)}
 />
 )}
 </span>
 );
};

export default UserAvatar;
